import React, { Component } from 'react';
import styled from 'styled-components';

class SuperButton extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    handleOnClick() {
        if(this.props.onClick) {
            this.props.onClick();
        }
    }

    render() { 
        return (
            <div className="hw-widget__super-button" style={this.props.style ?? {}} onClick={() => this.handleOnClick()}>
                {/* <div className="hw-widget__super-button__ball">
                    <i className="fas fa-arrow-right"></i>
                </div> */}
                {this.props.children}
            </div>
        );
    }
}
 
export default SuperButton;